export default __webpack_public_path__ + "static/2196-4c67a7ea4d01b3bfee179ba77bec9820.gif";